import React from 'react'
import Filter from './Filter'

class TasksFilter extends React.Component {

  render () {
    let taskFilter = []
    this.props.tasks.forEach((task) => {
      taskFilter.push(<Filter 
              key={task.id}
              filterBy={task} 
              type='task' 
              filterItems={this.props.filterItems}
            />)
          })
    return(
      <div className='tasks'>
        { taskFilter }
      </div>
    )
  }
}

export default TasksFilter
